import mountDynamicComponent from '~/plugins/mountDynamicComponent';
import FullPagePortal from "~/components/Plugins/FullPagePortal.vue";

export default defineNuxtPlugin(
    mountDynamicComponent({
        component: FullPagePortal,
        functionName: 'showFullPagePortal'
    })
);
